import React, { Component } from 'react';
import Firebase from 'firebase';

import img from '../assets/images/bg_1.jpg';

class SectionJoin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataContact: [],
      category: ''
    }
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    Firebase.database().ref('contact').on('value', data => {
      this.setState({dataContact: data.val()})
    })
  }

  handleChange(e) {
    const {name, value} = e.target
    this.setState({[name]: value})
  }
  
  render() { 
    let {dataContact, category} = this.state

    return (
      <section className="ftco-section ftco-subscribe img" style={{backgroundImage: `url(${img})`}}>
        <div className="overlay"></div>
          <div className="container">
            <div className="row justify-content-center pb-5">
              <div className="col-md-7 heading-section heading-section-white text-center">
                <h2 className="mb-4">Order Now</h2>
                <p>Pesan sekarang juga website yang anda dambakan dengan memakai teknologi yang di gunakan oleh para web developer professional.</p>
                <div className="row d-flex justify-content-center mt-4">
                  <div className="col-md-10">
                    <div action="#" className="subscribe-form">
                      <div className="form-group d-flex">
                        <input type="text" className="form-control" placeholder="Enter category website" name="category" onChange={this.handleChange} />
                        <a href={`https://api.whatsapp.com/send?phone=${dataContact.whatsapp}&text=Halo,%20Saya%20mau%20order%20websitenya%20ya%0A%0ANama:%0AKota:%0AKategori%20website:${category}`} target="_blank" rel="noopener noreferrer">
                          <input type="submit" value="Order" className="submit px-3" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </section>
    );
  }
}
 
export default SectionJoin;